import { useEffect, useState } from "react";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
// import ExportSales from "..x/Common/Modal/ExportSales";
// import ExportArticleSales from "../Common/Modal/ExportArticleSales";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import { Helmet } from "react-helmet";
import { salesRoutes } from "../../data";
import { useSaleArticelExportByDateQuery } from "../../services/saleApi";
import WareHouseDW from "../Common/CustomSelect/WareHouseDW";
import LoadingModal from "../Common/Modal/LoadingModal";
import ExportNav from "../Common/Nav/ExportNav";
import { signInUser } from "../Utility/Auth";
import { useSelector } from "react-redux";

const ExportArticleSale = () => {
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const auth = signInUser();
  const lang = useSelector((state) => state.languageReducer);

  const { aamarId, storeSettings } = auth;
  const [warehouse, setWarehouse] = useState("allWh");
  const { data, error, isLoading, isFetching, isSuccess, refetch } =
    useSaleArticelExportByDateQuery({
      startDate,
      endDate,
      warehouse,

      aamarId,
    });

  // console.log(startDate, endDate, data);
  // const [articleSale, setArticleSale] = useState([]);
  const [exportData, setExportData] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const [totalSalesVat, setTotalSalesVat] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [totalVat, setTotalVat] = useState(0);

  const [loader, setLoader] = useState(false);
  const handleLoaderClose = () => setLoader(false);
  // console.log(data);
  useEffect(() => {
    isLoading ? setLoader(true) : setLoader(false);
  }, [isLoading, isFetching]);

  useEffect(() => {
    refetch();
  }, [startDate, endDate, warehouse]);

  useEffect(() => {
    if (auth?.type === "admin") {
      setWarehouse("allWh");
    } else {
      setWarehouse(auth?.warehouse);
    }
  }, []);

  // useEffect(() => {
  //   if (data && data.length > 0)
  //     //TODO: Loop

  //     setFilteredData(data);
  // }, [isSuccess]);

  // console.log("warehouse", startDate, endDate, warehouse);

  const totalAmount = (mrp, qty) => {
    let amount = 0;
    amount = parseFloat(mrp) * parseFloat(qty);
    return amount;
  };
  const vatTotal = (mrp, qty, vat) => {
    let vatAmount = 0;
    if (vat !== 0) {
      // console.log(mrp, qty, vat / 100);
      vatAmount = parseFloat(mrp) * parseFloat(qty) * (parseFloat(vat) / 100);
    }
    // console.log(vatAmount);
    return vatAmount;
  };
  const eachDiscount = (mrp, qty, discount, total) => {
    let discountAmount = 0;
    if (discount !== 0) {
      let itemTotal = parseFloat(mrp) * parseFloat(qty);
      discountAmount = itemTotal * (parseFloat(discount) / parseFloat(total));
      // console.log("discount:", mrp, qty, itemTotal, discountAmount);
    }
    return discountAmount;
  };

  useEffect(() => {
    let articleSales = [];
    // let totalSaleVat = 0;
    // let totalSale = 0;
    // let totalVat = 0;
    data?.map((sale) =>
      sale?.products?.map((product) => {
        // console.log(product);
        articleSales = [
          ...articleSales,
          {
            invoice_no: sale?.invoiceId,
            date:
              sale?.createdAt &&
              format(new Date(sale?.createdAt), "MM/dd/yyyy"),
            // Product Loop
            code: product?.article_code,
            name: product?.name,
            tp: product?.tp,
            mrp: product?.mrp,
            qty: product?.qty,
            promo: product?.promo?.promo_price,
            vat: vatTotal(product?.mrp, product?.qty, product?.vat),
            discount: eachDiscount(
              product?.mrp,
              product?.qty,
              sale?.discount,
              sale?.total
            ),
            total: totalAmount(product?.mrp, product?.qty),
            grossTotal:
              totalAmount(product?.mrp, product?.qty) +
              vatTotal(product?.mrp, product?.qty, product?.vat) -
              (parseFloat(
                eachDiscount(
                  product?.mrp,
                  product?.qty,
                  sale?.discount,
                  sale?.total
                )
              ) +
                parseFloat(product?.promo?.promo_price)),
          },
        ];
        // totalSaleVat =
        //   totalSaleVat +
        //   totalAmount(product?.mrp, product?.qty) +
        //   vatTotal(product?.mrp, product?.qty, product?.vat) -
        //   (eachDiscount(
        //     product?.mrp,
        //     product?.qty,
        //     sale?.discount,
        //     sale?.total
        //   ) +
        //     parseFloat(product?.promo?.promo_price));
        // totalSale = totalSale + totalAmount(product?.mrp, product?.qty);
        // totalVat =
        //   totalVat + vatTotal(product?.mrp, product?.qty, product?.vat);
      })
    );

    // console.log("product", articleSales);
    setExportData(articleSales);
    // setArticleSale(articleSales);
    // setTotalSalesVat(totalSaleVat);
    // setTotalSales(totalSale);
    // setTotalVat(totalVat);
  }, [isSuccess]);

  useEffect(() => {
    let totalSaleVat = 0;
    let totalSale = 0;
    let totalVat = 0;

    if (exportData?.length > 0) {
      exportData.forEach((product) => {
        const mrp = product?.mrp || 0;
        const qty = product?.qty || 0;
        const vat = product?.vat || 0;
        const promoPrice = parseFloat(product?.promo?.promo_price) || 0;
        const discount = eachDiscount(
          mrp,
          qty,
          product?.discount,
          product?.total
        );

        const saleAmount = totalAmount(mrp, qty);
        const vatAmount = vatTotal(mrp, qty, vat);

        totalSaleVat += saleAmount + vatAmount - (discount + promoPrice);
        totalSale += saleAmount;
        totalVat += vatAmount;
      });
    }

    setTotalSalesVat(totalSaleVat);
    setTotalSales(totalSale);
    setTotalVat(totalVat);
  }, [exportData]);

  // console.log("export data", exportData);

  // const handleSearch = (e) => {};
  const filterByArticleCode = (e) => {
    const searchValue = e.trim().toLowerCase();
    // console.log("exportData", exportData);
    if (searchValue.length > 0) {
      const filtered = exportData?.filter((pro) =>
        pro.code.includes(searchValue)
    );
    // console.log("exportData filtered", filtered);

      setExportData(filtered);
    }
  };

  const handleOnchangeWareHouseFrom = (e) => {
    if (e.option !== "no-warehouse") {
      setWarehouse(e.option);
    } else {
      setWarehouse("allWh");
    }
  };
  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [`${storeSettings?.address?.street || "No-Street"}`],
    [
      `${storeSettings?.address?.city || "No-City"}-${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],
    [
      `For the Period: ${format(new Date(startDate), "MM-dd-yyyy")} to ${format(
        new Date(endDate),
        "MM-dd-yyyy"
      )}`,
    ],
    ["Article Sale Report"],

    [], // Empty row for spacing
  ];

  // console.log("filteredData", filteredData);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Aamar-Dokan-Sale-Export</title>
      </Helmet>

      <div className="container-fluid">
        <LoadingModal
          title={"Please Wait"}
          onShow={loader}
          handleClose={handleLoaderClose}
        ></LoadingModal>
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title={lang?.articleSales}></Header>
            <div className="row mt-3">
              {/* Date Range, Article Code, and Warehouse Filter */}
              <div className="col-md-5">
                <div className=" mb-2">
                  <div className="d-flex align-items-center gap-2">
                    {/* Start Date */}
                    <DatePicker
                      selected={new Date(startDate)}
                      className="form-control"
                      placeholderText="Start Date"
                      onChange={(date) =>
                        setStartDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                      // style={{ width: "300px" }} // Consistent width for inputs
                    />

                    {/* End Date */}
                    <DatePicker
                      selected={new Date(endDate)}
                      className="form-control"
                      placeholderText="End Date"
                      onChange={(date) =>
                        setEndDate(format(new Date(date), "MM-dd-yyyy"))
                      }
                      // style={{ width: "300px" }}
                    />
                  </div>

                  <div className="d-flex align-items-center gap-2 mt-2">
                    {/* Article Code */}
                    <input
                      type="text"
                      name="product"
                      className="form-control"
                      placeholder="Article Code"
                      onChange={(e) => filterByArticleCode(e.target.value)}
                      style={{ width: "50%" }}
                    />

                    {/* Warehouse Dropdown (Visible for Admins Only) */}
                    {auth?.type === "admin" && (
                      <div
                        className="mt-2 mt-md-0 mb-2 mb-md-0 "
                        style={{
                          width:
                            window.innerWidth >= 1024
                              ? 280
                              : window.innerWidth >= 768
                              ? 280
                              : "100%", // Adjust width based on screen size
                        }}
                      >
                        <WareHouseDW
                          id="warehouse"
                          name="warehouse"
                          handleOnChange={handleOnchangeWareHouseFrom}
                          className="form-control "
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Export Navigation */}
              <div className="col-md-7 d-flex justify-content-end align-items-start">
                <ExportNav
                  preheader={preHeader}
                  Routes={salesRoutes}
                  data={exportData}
                  title="Article Sale"
                />
              </div>
            </div>

            {/* <Link to="/category-sales" className="btn btn-dark float-end my-2  mx-2">Category Sales </Link> */}
            <div
              className="table-responsive"
              style={{
                maxHeight: window.innerWidth <= 768 ? "400px" : "auto",
                overflowY: "auto",
              }}
            >
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th style={{ whiteSpace: "nowrap" }}>Invoice ID</th>
                    <th style={{ whiteSpace: "nowrap" }}>Date</th>
                    <th className="text-center">Code</th>
                    <th
                      style={{
                        width: "20%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      Name
                    </th>
                    <th className="text-center">TP</th>
                    <th className="text-center">MRP</th>
                    <th className="text-center">Qty</th>
                    <th className="text-center">Dis</th>
                    <th className="text-center">Promo</th>
                    <th className="text-center">VAT</th>
                    <th className="text-end">Total</th>
                    <th className="text-end">GrossTotal</th>
                  </tr>
                </thead>
                <tbody>
                  {exportData ? (
                    exportData.map((product) => (
                      <tr key={product?.invoice_no}>
                        <td style={{ fontWeight: "bold" }}>
                          {product?.invoice_no}
                        </td>
                        <td>{product?.date}</td>
                        <td className="text-center">{product?.code}</td>
                        <td
                          style={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {product?.name}
                        </td>
                        <td className="text-center">
                          {new Intl.NumberFormat().format(
                            parseFloat(product?.tp).toFixed(2)
                          )}
                        </td>
                        <td className="text-center">
                          {new Intl.NumberFormat().format(
                            parseFloat(product?.mrp).toFixed(2)
                          )}
                        </td>
                        <td className="text-center">
                          {new Intl.NumberFormat().format(
                            parseFloat(product?.qty).toFixed(3)
                          )}
                        </td>
                        <td className="text-center">
                          {parseFloat(product?.discount || 0).toFixed(2)}
                        </td>
                        <td className="text-center">{product?.promo}</td>
                        <td className="text-center">
                          {new Intl.NumberFormat().format(
                            parseFloat(product?.vat).toFixed(2)
                          )}
                        </td>
                        <td className="text-end">
                          {new Intl.NumberFormat().format(
                            parseFloat(product?.total).toFixed(2)
                          )}
                        </td>
                        <td className="text-end">
                          {new Intl.NumberFormat().format(
                            parseFloat(product?.grossTotal).toFixed(2)
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={12} className="text-center">
                        Loading...
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td colSpan={9} className="text-end">
                      <b>Total</b>
                    </td>
                    <td className="text-end">
                      <b>
                        {new Intl.NumberFormat().format(
                          parseFloat(totalVat || 0).toFixed(2)
                        )}
                      </b>
                    </td>
                    <td className="text-end">
                      <b>
                        {new Intl.NumberFormat().format(
                          parseFloat(totalSales || 0).toFixed(2)
                        )}
                      </b>
                    </td>
                    <td className="text-end">
                      <b>
                        {new Intl.NumberFormat().format(
                          parseFloat(totalSalesVat || 0).toFixed(2)
                        )}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportArticleSale;
